// fetchUtils.js

import { getStoredWeatherData, storeWeatherData } from './StorageUtils';

const GOOGLE_API_KEY = 'AIzaSyAVd8hOm79lUcB-ZyZf0MlfT-XR3yTX5CI';
const SPREADSHEET_ID = '10OASKdt3-K49U2Gz5WKxZH0GQgDQBFxA2TdkmR7XZ68';
const RANGE = 'Sheet1!A:E';

export async function fetchSpreadsheetData(gapi, forceRefresh) {
    try {
        await gapi.client.load('sheets', 'v4');
        const response = await gapi.client.sheets.spreadsheets.values.get({
            spreadsheetId: SPREADSHEET_ID,
            range: RANGE,
            key: GOOGLE_API_KEY
        });
        if (response.result.values) {
            const rows = response.result.values.slice(1); // Skip header row
            const zones = rows.map(row => {
                let webcamUrls;
                try {
                    webcamUrls = JSON.parse(row[2]); // Parse JSON object for webcam names and URLs
                } catch (error) {
                    console.error(`Error parsing JSON for row ${row}:`, error);
                    webcamUrls = [];
                }
                return {
                    title: row[0], // Zone title
                    codes: row[1].split(',').map(code => code.trim()), // Airport codes
                    webcamUrls: webcamUrls, // Use parsed JSON or empty array
                    cwa: row[4], // Extract CWA value from the 4th column (index 3)
                };
            });
            return zones;
        } else {
            console.error('No data found in the spreadsheet.');
            return [];
        }
    } catch (error) {
        console.error('Error fetching spreadsheet data:', error);
        return [];
    }
}

export async function fetchWeatherData(zones, forceRefresh) {
    const data = [];

    for (const zone of zones) {
        const zoneData = {
            title: zone.title,
            airports: [],
            cwa: zone.cwa,
        };

        for (const code of zone.codes) {
            const storedData = getStoredWeatherData(code);
            const airportData = {
                code,
                webcamUrls: zone.webcamUrls, // Include webcamUrls for each airport
                metarData: [], // Initialize as array
                tafData: [], // Initialize as array
                isCached: false,
                isError: false
            };

            if (storedData && !forceRefresh) {
                airportData.metarData = storedData.metarData;
                airportData.tafData = storedData.tafData;
                airportData.isCached = true;
            } else {
                try {
                    const metarResponse = await fetch(`https://api.checkwx.com/metar/${code}/decoded`, {
                        headers: {
                            'X-API-Key': '0221e0aa85274a45a7e146377c'
                        }
                    });
                    const metarData = await metarResponse.json();
                    const tafResponse = await fetch(`https://api.checkwx.com/taf/${code}/nearest`, {
                        headers: {
                            'X-API-Key': '0221e0aa85274a45a7e146377c'
                        }
                    });
                    const tafData = await tafResponse.json();
                    storeWeatherData(code, metarData, tafData);
                    airportData.metarData.push(metarData);
                    airportData.tafData.push(tafData);
                } catch (error) {
                    console.error('Error fetching weather data for ', code, error);
                    airportData.isError = true;
                }
            }
            zoneData.airports.push(airportData);
        }
        data.push(zoneData);
    }

    return data;
}

export async function fetchForecast(cwa) {
    try {
        const response = await fetch(`https://q2yy4pt5bplu25bbb4gwrlhvgm0qytgn.lambda-url.us-east-2.on.aws/?cwa=${cwa}&type=forecast`);
        if (!response.ok) {
            throw new Error(`Failed to fetch forecast data`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching forecast data:', error);
        return { error: 'Failed to fetch forecast data' };
    }
}
